import { z } from 'zod';

export const TransactionTypeSchema = z.enum([
  'carrier_capture_order_earnings',
  'carrier_payout',
  'customer_single_order_payment',
  'customer_invoice_payment',
  'customer_multi_invoice_payment',
  'customer_pay_all_due_payments',
  'customer_capture_order_amount',
  'customer_advance_payment',
  'wallet_debit',
  'wallet_credit',
  'wallet_debit_payment_failure',
  'refund',
  'cashback',
]);

export type TransactionType = z.infer<typeof TransactionTypeSchema>;
